import { usePermissions } from 'react-admin';
import { PERMISSIONS } from '../../constants';
import { getEmployeeType } from '../../lib';
import { EmployeeType } from '../../models';

/**
 * Só funcionário `type = chain` com a permissão `attendant-target` vê o convite (spec seção 8).
 * `loading` evita que a tela redirecione antes de o react-admin resolver as permissões.
 */
export const useOfferGate = (): { allowed: boolean; loading: boolean } => {
  const { permissions, isPending } = usePermissions();
  let isChain = false;
  try { isChain = getEmployeeType() === EmployeeType.chain; } catch { /* localStorage ilegível: sem convite */ }
  const allowed = isChain && !!permissions?.includes(PERMISSIONS.ATTENDANT_TARGET);
  return { allowed, loading: isPending };
};
